import { render } from "./SectionsAnalyticsPieChart.vue?vue&type=template&id=12efccdd&scoped=true"
import script from "./SectionsAnalyticsPieChart.vue?vue&type=script&lang=js"
export * from "./SectionsAnalyticsPieChart.vue?vue&type=script&lang=js"

import "./SectionsAnalyticsPieChart.vue?vue&type=style&index=0&id=12efccdd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12efccdd"]])

export default __exports__